import { ISharingProfile, ISharingProfileCreateRequest, ISharingProfileShort, ISharingProfileUpdateRequest, ISharingProfileDeleteRequest, IUpdateUsersRequest } from './../entities/sharing-profile';
import { IPage } from "../entities/page";
import { DataService } from "./data-service";
import { ISharingProfilesRequestParams } from '../entities/sharing-profile';

class SharingProfileService extends DataService {
  constructor() {
    super("sharing/profile");
  }

  getPage(requestParams: ISharingProfilesRequestParams): Promise<IPage<ISharingProfileShort>> {
    return this.api.get<IPage<ISharingProfileShort>>(null, requestParams);
  }

  get(id: number): Promise<ISharingProfile> {
    return this.api.get<ISharingProfile>(id, null);
  }

  create(createRequest: ISharingProfileCreateRequest): Promise<ISharingProfile> {
    return this.api.post<ISharingProfile>("", createRequest);
  }

  update(updateRequest: ISharingProfileUpdateRequest, updatedAt: Date): Promise<ISharingProfile> {
    return this.api.putConditionally<ISharingProfile>(updateRequest.id, updateRequest);
  }

  updateUsers(sharingProfileId: number, updateUsersRequest: IUpdateUsersRequest): Promise<ISharingProfile> {
    return this.api.postConditionally(`update-users/${sharingProfileId}`, updateUsersRequest);
  }

  delete(deleteRequest: ISharingProfileDeleteRequest): Promise<void> {
    return this.api.post("delete", deleteRequest);
  }

  save(sharingProfile: ISharingProfile, ignoreFolderName?: boolean): Promise<ISharingProfile> {
    if (sharingProfile.id) {
      return this.update(this.getUpdateRequest(sharingProfile, ignoreFolderName), new Date(sharingProfile.updatedAt));
    }
    return this.create(this.getCreateRequest(sharingProfile, ignoreFolderName));
  }

  private getCreateRequest(sharingProfile: ISharingProfile, ignoreFolderName?: boolean): ISharingProfileCreateRequest {
    return {
      storagePoolId: sharingProfile.StoragePool.id,
      consoleName: sharingProfile.consoleName,
      folderName: sharingProfile.folderName,
      canEdit: sharingProfile.canEdit,
      ignoreFolderName,
      users: sharingProfile.users.map(user => ({ id: user.id}))
    };
  }

  private getUpdateRequest(sharingProfile: ISharingProfile, ignoreFolderName?: boolean): ISharingProfileUpdateRequest {
    return {
      ...this.getCreateRequest(sharingProfile, ignoreFolderName),
      id: sharingProfile.id,
      updatedAt: new Date(sharingProfile.updatedAt)
    };
  }
}

export const sharingProfileService = new SharingProfileService();
